export default __webpack_public_path__ + "static/media/74.9bf68d51.jpg";